export { default } from "./LITApprovedBadge";
